import React, { useState } from 'react';
import styles from './DeleteNotifications.module.css';

const DeleteNotifications = ({ message = "Are you sure you want to delete this?", onConfirm, onCancel }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleConfirm = () => {
    setIsVisible(false);  // Ascunde notificarea
    onConfirm();  // Apelează funcția de ștergere
  };

  const handleCancel = () => {
    setIsVisible(false);  // Ascunde notificarea
    if (onCancel) onCancel();  // Dacă există o funcție de anulare, o apelează
  };

  if (!isVisible) return null;

  return (
    <div className={styles.deletenotificationContainer}>
      <div className={styles.deletenotification}>
        <p>{message}</p>
        <div className={styles.deletebuttonGroup}>
          <button className={styles.deleteconfirmButton} onClick={handleConfirm}>Yes</button>
          <button className={styles.deletecancelButton} onClick={handleCancel}>No</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteNotifications;
